import { Directive, ElementRef, Renderer2, Input, OnInit } from '@angular/core';
import { AuthenticationService } from '@app/_services';

@Directive({
  selector: '[appPermission]'
})
export class PermissionDirective implements OnInit {
  @Input() appPermission: [];
  @Input() conditions: any;
  @Input() operator;

  constructor(private renderer: Renderer2, private elmRef: ElementRef, private AuthService: AuthenticationService) { }

  ngOnInit() {
    let elemStyle = this.elmRef.nativeElement.style;

    switch (this.operator) {
      case 'OR':
        if (this.AuthService.userHasPermission(this.appPermission) || this.conditions) {
          elemStyle.removeProperty('display');
        } else {
          elemStyle.display = 'none';
        }
        break;
      case 'AND':
        if (this.AuthService.userHasPermission(this.appPermission) && this.conditions) {
          elemStyle.removeProperty('display');
        } else {
          elemStyle.display = 'none';
        }
        break;
      default:
        if (this.appPermission == undefined || this.AuthService.userHasPermission(this.appPermission)) {
          elemStyle.removeProperty('display');
        } else {
          elemStyle.display = 'none';
        }
    }

  }

}
